"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryOptionsQuery = void 0;
var _fetching = require("@ori/fetching");
var _swrConfig = require("../constants/swrConfig");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _utils = require("../utils");
const fetchData = async options => {
  const promise = (0, _utils.getUrl)(options);
  promise.catch(error => {
    _logger.mainLogger.error(error, {
      action: 'useDeliveryOptionsQuery'
    });
  });
  return promise;
};
const useDeliveryOptionsQuery = ({
  isEnabled = true,
  onSuccess
} = {}) => {
  const {
    cacheKeys,
    urlOptions
  } = (0, _hooks.useUrlOptions)('/system/ajax/DeliverySelection/GetDeliveryOptions');
  const swrOptions = {
    ..._swrConfig.errorHandlingSwrOptions,
    onSuccess: deliveryOptionsData => {
      (0, _logger.logInfo)('useDeliveryOptionsQuery() hook finished successfully');
      onSuccess?.(deliveryOptionsData);
    }
  };
  const {
    data,
    error,
    isValidating,
    mutate
  } = (0, _fetching.useSWR)(isEnabled ? cacheKeys : null, async () => fetchData(urlOptions), swrOptions);
  return {
    deliveryOptions: data,
    error,
    isDeliveryOptionsLoading: isValidating,
    mutateDeliveryOptions: mutate
  };
};
exports.useDeliveryOptionsQuery = useDeliveryOptionsQuery;